import styled from '@emotion/styled';
import React, { useState } from 'react';
import axios from 'axios';
import { FormatPrice } from 'dw-au-react-components';

const StyledShippingCalculator = styled.div`
	input[type='number']::-webkit-inner-spin-button,
	input[type='number']::-webkit-outer-spin-button {
		-webkit-appearance: none;
		-moz-appearance: none;
		appearance: none;
		margin: 0;
	}

	input {
		width: 70%;
		min-height: 48px;
		padding: 10px;
		border: 1px solid rgb(204, 204, 204);
		transition: border-color 0.2s ease 0s;
		color: rgba(0, 0, 0, 0.76);
		outline: 0;
	}
`;

function ShippingCalculator({ brandData }) {
	const [zipCode, setZipCode] = useState('');
	const [shippingRate, setShippingRate] = useState(null);

	const getShippingPrice = () => {
		if (zipCode) {
			axios.get(`/api/checkout/delivery/cost/${zipCode}`).then((response) => {
				let shippingRate = FormatPrice(response.data.response.price);
				setShippingRate(shippingRate);
			});
		}
	};

	const handleOnChange = (postCodeValue) => {
		if (postCodeValue.length < 1) {
			setShippingRate(null);
			setZipCode('');
		} else if (postCodeValue.length <= 4) {
			setZipCode(postCodeValue);
		}
	};

	return (
		<>
			<StyledShippingCalculator className='answer d-flex align-items-center'>
				<input
					onChange={(e) => handleOnChange(e.target.value)}
					placeholder={
						brandData.country === 'AU'
							? 'Enter your postcode: 2205'
							: 'Enter your postcode: 8013'
					}
					type='number'
					value={zipCode}
					className='mr-20'
					maxLength={4}
				/>
				<button
					onClick={() => getShippingPrice()}
					className={`btn btn-${zipCode.length === 4 ? 'primary' : 'disabled'}`}
				>
					CALCULATE
				</button>
			</StyledShippingCalculator>

			<div className={`shipping-rate ${shippingRate ? '' : 'invisible'}`}>
				<h6 className='font-weight-bold mb-12 pt-12'>
					Your delivery rate is {shippingRate}
				</h6>

				{brandData.brand !== 'vws' && brandData.country === 'NZ' ? (
					<div>* All orders over $395 qualify for FREE delivery.</div>
				) : (
					<div>* All orders over $350 qualify for FREE delivery.</div>
				)}
			</div>
		</>
	);
}

export default ShippingCalculator;
